@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.text {
  position: relative;
  z-index: 10;
  margin-top: 2.12rem;
  white-space: pre-line;
  vertical-align: bottom;
  font-family: Avenir, Montserrat, Poppins, serif;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2.25rem;
  text-align: left;
  color: #fff;

  a {
    color: #abe6df;
  }

  @media (max-width: map.get($grid-breakpoints, lg)) {
    margin-top: 1rem;
    font-size: 0.75rem;
    line-height: 1.125rem;
  }

  &--subtitle {
    font-weight: 600;
  }

  &:last-child {
    margin-top: 0;
    margin-bottom: 3.5rem;
  }
}

.logo-wrapper {
  margin-bottom: 7.75rem;
}
